import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useFasePDP = () => {
  const [registro, setRegistro] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchRegistro = async () => {
      try {
        const response = await httpClient.get(`/api/produtopdp/fasepdp`);
        // console.log(response.data);
        const options = response.data.map(
          (registro: { value: number; label: string }) => ({
            value: registro.value.toString(),
            label: registro.label,
          }),
        );
        setRegistro(options);
      } catch (error) {
        console.error('Erro ao buscar registros', error);
      }
    };

    fetchRegistro();
  }, []);

  return registro;
};
